import React from 'react';
import { useTranslation } from 'react-i18next';
import './LanguageSwitcher.css';

export const LanguageSwitcher: React.FC = () => {
  const { t, i18n } = useTranslation();
  const currentLang = i18n.language;

  const switchLanguage = () => {
    const newLang = currentLang === 'it' ? 'en' : 'it';
    const pathname = window.location.pathname;
    const search = window.location.search;
    const hash = window.location.hash;
    
    let newPath;
    
    if (newLang === 'en') {
      // Switch to English path
      if (pathname.startsWith('/en')) {
        // Already on English path, no change needed
        return;
      } else {
        // Add /en prefix to current path
        newPath = '/en' + pathname;
      }
    } else {
      // Switch to Italian (remove /en prefix)
      if (pathname.startsWith('/en')) {
        // Remove /en prefix
        newPath = pathname.replace('/en', '') || '/';
      } else {
        // Already on Italian path, no change needed
        return;
      }
    }
    
    // Change language and navigate to new path
    i18n.changeLanguage(newLang);
    window.history.pushState({}, '', newPath + search + hash);
    
    // Trigger a popstate event to update React Router
    window.dispatchEvent(new PopStateEvent('popstate'));
  };

  return (
    <button 
      className="language-switcher"
      onClick={switchLanguage}
      title={t('buttons.switchLanguage')}
      aria-label={t('buttons.switchLanguage')}
    >
      <span className="flag-icon">
        {currentLang === 'it' ? '🇬🇧' : '🇮🇹'}
      </span>
      <span className="lang-text">
        {currentLang === 'it' ? 'EN' : 'IT'}
      </span>
    </button>
  );
};